import React, { useState, useEffect, useRef } from 'react';
import styles from './style.less';
import classnames from 'classnames';
import { useRequest, request, useLocation } from 'umi';
import { useUpdateEffect } from 'ahooks';
import {
  CaretUpOutlined,
  CaretRightOutlined,
  CaretDownOutlined,
  CaretLeftOutlined,
  PictureOutlined,
  VideoCameraOutlined,
} from '@ant-design/icons';
import { message, Space, Button } from 'antd';

import { Cell, DateSelect } from 'zarm';

let apiPrefix = 'https://open.mokan.cn';

export default () => {
  const location = useLocation();
  const {
    type,
    projectId,
    contractNo,
    timestamp,
    clientCode,
    sign,
    hideYun,
    hideVoiceBtn,
    hidePlaybackBtn,
    talkback,
    setPresetPosition, //预置位
    bindTime, //回放开始时间
  } = location.query;

  if (type === 'test') {
    apiPrefix = 'https://test-open.mokan.cn';
  }

  const [value, setValue] = useState('');
  const [detail, setDetail] = useState(null);
  const tempObj = {};
  if (contractNo) {
    tempObj.contractNo = contractNo;
  } else if (projectId) {
    tempObj.projectId = projectId;
  }

  const _getData = () => {
    if (!tempObj.projectId && !tempObj.contractNo) {
      return message.error('参数缺失');
    }
    return request(`${apiPrefix}/openapi/project/beenBindDeviceList`, {
      method: 'get',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      params: {
        ...tempObj,
      },
    });
  };
  const _getDetail = () => {
    return request(`${apiPrefix}/openapi/project/getDetail`, {
      method: 'get',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      params: {
        id: tempObj.projectId,
        contractNo,
      },
    });
  };
  useEffect(() => {
    _getDetail().then((res) => {
      setDetail(res.data);
    });
  }, []);
  const { data, loading } = useRequest(
    () => {
      return _getData();
    },
    {
      onSuccess(response) {
        // console.log(response);
      },
    },
  );

  if (!data) {
    return null;
  }

  const _getLiveUrl = (deviceId) => {
    var liveUrl = `/third-link-web/live.html?type=${type}&deviceId=${deviceId}&timestamp=${timestamp}&sign=${sign}&clientCode=${clientCode}`;
    if (hideYun) {
      liveUrl = liveUrl + `&hideYun=${hideYun}`;
    }
    if (hideVoiceBtn) {
      liveUrl = liveUrl + `&hideVoiceBtn=${hideVoiceBtn}`;
    }
    if (talkback) {
      liveUrl = liveUrl + `&talkback=${talkback}`;
    }
    if (setPresetPosition) {
      liveUrl = liveUrl + `&setPresetPosition=${setPresetPosition}`;
    }
    return liveUrl;
  };

  return (
    <div className={styles.container}>
      <div className="valueList">
        {data?.data?.length > 0 ? (
          data?.data?.map((v) => {
            return (
              <div className="itemBox" key={v.deviceId}>
                <div className="item">
                  <img
                    src={v.snapshotsUrl || require('./assets/default.png')}
                    alt=""
                    className="img"
                    onClick={() =>
                      v.online
                        ? (window.location.href = _getLiveUrl(v.deviceId))
                        : null
                    }
                  />
                  {v.online && (
                    <img
                      src={require('./assets/status_play.png')}
                      alt=""
                      className="statusPlay"
                      onClick={() =>
                        v.online
                          ? (window.location.href = _getLiveUrl(v.deviceId))
                          : null
                      }
                    />
                  )}
                  {v.online && (
                    <div className="playBut">
                      <img
                        src={require('./assets/status.gif')}
                        alt=""
                        className="playButImg"
                      />
                      <div className="playButText">设备在线</div>
                    </div>
                  )}
                  {!v.online && (
                    <div className="offlineBox">
                      <div className="offlineContent">
                        <img
                          src={require('./assets/offline.png')}
                          alt=""
                          className="offlineImg"
                        />
                        <div className="fs14 fw500">设备已离线</div>
                        <div className="fs12">
                          请及时联系{detail?.supervisor?.positionName}、
                          {detail?.manager?.positionName}恢复在线
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="info">
                    <div className="leftBox">
                      <div className="name">{v.area}</div>
                      {!v.online && (
                        <div className={v.online ? 'onLine' : 'offLine'}>
                          {v.online ? '在线' : '离线'}
                        </div>
                      )}
                    </div>
                    {/* {v.online && !hidePlaybackBtn && (
                      <div
                        className="infoPlay"
                        onClick={() =>
                          (window.location.href = `https://static.mokan.cn/third-link/playback.html?type=${type}&deviceId=${v.deviceId}&timestamp=${timestamp}&sign=${sign}&clientCode=${clientCode}`)
                        }
                      > */}
                    {/* <img
                          src={require('./assets/status.png')}
                          alt=""
                          className="playImg"
                          // onClick={() =>
                          //   window.open(
                          //     `https://static.mokan.cn/third-link/playback.html?type=${type}&deviceId=${v.deviceId}&timestamp=${timestamp}&sign=${sign}&clientCode=${clientCode}`,
                          //   )
                          // }
                        /> */}
                    {/* <div className="playName">看回放</div>
                      </div>
                    )} */}
                  </div>
                  <div className="btnBox">
                    <Space>
                      {v.online && !hidePlaybackBtn && (
                        <Button
                          className="playback"
                          icon={<VideoCameraOutlined />}
                          onClick={() => {
                            window.location.href = `/third-link-web/playback.html?type=${type}&deviceId=${v.deviceId}&timestamp=${timestamp}&sign=${sign}&clientCode=${clientCode}&bindTime=${bindTime}&hideVoiceBtn=${hideVoiceBtn}`;
                          }}
                        >
                          视频回放
                        </Button>
                      )}
                      <Button
                        icon={<PictureOutlined />}
                        className="snapshoot"
                        onClick={() => {
                          window.location.href = `/third-link-web/album.html${window.location.search}&deviceId=${v.deviceId}`;
                        }}
                      >
                        工地快照
                      </Button>
                    </Space>
                  </div>
                  {/* <div className="line"></div> */}
                  {/* <div className="buttons">
                    {v.online ? (
                      <div
                        className="play onLineColor"
                        onClick={() =>
                          window.open(
                            `https://static.mokan.cn/third-link/live.html?type=${type}&deviceId=${v.deviceId}&timestamp=${timestamp}&sign=${sign}&clientCode=${clientCode}`,
                          )
                        }
                      >
                        <img
                          src={require('./assets/play_y.png')}
                          alt=""
                          className="playImg"
                        />
                        <div className="playName">直播</div>{' '}
                      </div>
                    ) : (
                      <div className="play offLineColor">
                        <img
                          src={require('./assets/play_n.png')}
                          alt=""
                          className="playImg"
                        />
                        <div className="playName">直播</div>
                      </div>
                    )}
                    {v.online ? (
                      <div
                        className="play onLineColor"
                        onClick={() =>
                          window.open(
                            `https://static.mokan.cn/third-link/playback.html?type=${type}&deviceId=${v.deviceId}&timestamp=${timestamp}&sign=${sign}&clientCode=${clientCode}`,
                          )
                        }
                      >
                        <img
                          src={require('./assets/replay_y.png')}
                          alt=""
                          className="playImg"
                        />
                        <div className="playName">回放</div>
                      </div>
                    ) : (
                      <div className="play offLineColor">
                        <img
                          src={require('./assets/replay_n.png')}
                          alt=""
                          className="playImg"
                        />
                        <div className="playName">回放</div>
                      </div>
                    )}
                  </div> */}
                </div>
              </div>
            );
          })
        ) : (
          <div className="temp">
            <div className="title">暂无资源</div>
          </div>
        )}
      </div>
      {/* <div className="bottomBox">
        <div
          className="botbut"
          onClick={() => {
            window.location.href = `https://static.mokan.cn/third-link/album.html${window.location.search}`;
          }}
        >
          {`工地快照 >`}
        </div> */}
      {/* <Button
          block
          ghost
          theme="primary"

        >
          工地快照
        </Button> */}
      {/* </div> */}
    </div>
  );
};
